import React from 'react';
import { Button, Container, Modal } from 'react-bootstrap';
import OrderDetails, { IOrder } from '../../orderDetails';

interface Props {
  t: any,
  selectedPurchase: IOrder | undefined,
  setSelectedPurchase: any,
}

const SelectedPurchaseModal = (props: Props) => {
  return (
        <>
        <Modal show={props.selectedPurchase !== undefined} backdrop='static' keyboard={false} size='xl' centered={true}>
            <Modal.Body>
              <Container>
                <OrderDetails data={props.selectedPurchase} />
              </Container>
            </Modal.Body>
            <Modal.Footer>
              <Button variant='primary' onClick={() => props.setSelectedPurchase(undefined)}>
                {props.t('CLOSE')}
              </Button>
            </Modal.Footer>
        </Modal>
        </>
  );
};

export default SelectedPurchaseModal;